import React, { createContext, useState } from 'react'
import Modal from './Modal'

const ModalContext = createContext()

function useModal(){
    const [isShow, setShow] = useState(false)
    const [isDark, setDark] = useState(false)
    const [isShowHeader, setShowHeader] = useState(true)
    const [header, setHeader] = useState("")
    const [component, setComponent] = useState()
    const [disableBackDrop, setDisableBackDrop] = useState(true)

    return { 
        isShow, isDark, component, header, isShowHeader, disableBackDrop,
        setShow, setDark, setComponent, setHeader, setShowHeader, setDisableBackDrop
    }
}

function ModalProvider(props){
    const modal = useModal()

    return(
        <ModalContext.Provider value={modal}>
            { modal.isShow ?
                <Modal
                header={modal.header}
                disableBackDrop={modal.disableBackDrop}
                isShowHeader={modal.isShowHeader}
                isShow={modal.isShow}
                isDark={modal.isDark}
                >
                    {modal.component}
                </Modal>
                :null
            }
            {props.children}
        </ModalContext.Provider>
    )
}

export { ModalContext, ModalProvider }